if (!customElements.get('shoppable-slider')) {
  class ShoppableSlider extends HTMLElement {
    constructor() {
      super();
      this.currentSlide = 0;
      this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
      this.slides = this.querySelectorAll(`.slide-content-${this.sectionId}`);
      this.hotspots = this.querySelectorAll(`.hotspot-${this.sectionId}`);
      this.prevArrow = this.querySelector(`.prev-arrow-${this.sectionId.replace(/-/g, '_')}`);
      this.nextArrow = this.querySelector(`.next-arrow-${this.sectionId.replace(/-/g, '_')}`);
      this.makeSetButton = this.querySelector('.make-this-your');
      this.totalSlides = this.slides.length;
      this.bundleDiscountPercent = parseInt(this.dataset.bundleDiscountPercent || '20', 10);
      this.editName = this.dataset.editName || '';
      // 2026-10-15: rounded full-set prices. All items selected + subtotal == sum of sale prices -> show full-set price, auto-apply per-Edit fixed code.
      this.fullSetDeals = {
        'The Travel Edit': { code: 'EDITTRAVEL', sumCents: 27840, priceCents: 21900 },
        'The Workday Edit': { code: 'EDITWORKDAY', sumCents: 31760, priceCents: 24900 },
        'The Weekend Edit': { code: 'EDITWEEKEND', sumCents: 65920, priceCents: 52500 },
        'The Date Night Edit': { code: 'EDITDATENIGHT', sumCents: 23040, priceCents: 17900 },
      };
      this.init();
    }

    init() {
      this.hotspots.forEach((hotspot, index) => {
        hotspot.addEventListener('click', () => this.switchSlide(index));
      });
      if (this.prevArrow) this.prevArrow.addEventListener('click', () => this.prevSlide());
      if (this.nextArrow) this.nextArrow.addEventListener('click', () => this.nextSlide());
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.prevSlide();
        if (e.key === 'ArrowRight') this.nextSlide();
      });
      // CHANGED (P0-1 fix): button opens review drawer instead of silent bulk-add
      if (this.makeSetButton) {
        this.makeSetButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.openReviewDrawer();
        });
      }
      this.updateSlides();
    }

    switchSlide(i) {
      if (i >= 0 && i < this.totalSlides) { this.currentSlide = i; this.updateSlides(); }
    }
    nextSlide() { if (this.currentSlide < this.totalSlides - 1) { this.currentSlide++; this.updateSlides(); } }
    prevSlide() { if (this.currentSlide > 0) { this.currentSlide--; this.updateSlides(); } }
    updateSlides() {
      this.slides.forEach((s, i) => s.classList.toggle('active', i === this.currentSlide));
      this.hotspots.forEach((h, i) => h.classList.toggle('active', i === this.currentSlide));
      if (this.prevArrow) this.prevArrow.disabled = (this.currentSlide === 0);
      if (this.nextArrow) this.nextArrow.disabled = (this.currentSlide === this.totalSlides - 1);
    }

    // ─── P0-1 FIX: Review Drawer ───
    openReviewDrawer() {
      const items = Array.from(this.slides).map(slide => {
        const variants = JSON.parse(slide.dataset.variantsJson || '[]');
        return {
          slideId: slide.id,
          productId: slide.dataset.productId,
          productHandle: slide.dataset.productHandle,
          productTitle: slide.dataset.productTitle || 'Product',
          image: slide.dataset.image || '',
          priceCents: parseInt(slide.dataset.priceCents || '0', 10),
          variantId: slide.dataset.variantId,
          variants: variants,
          requiresVariantChoice: slide.dataset.requiresVariantChoice === 'true',
          checked: true,
          // B1 fix: multi-variant items (ring sizes, metals) must be picked explicitly
          selectedVariantId: slide.dataset.requiresVariantChoice === 'true' ? null : slide.dataset.variantId,
        };
      }).filter(it => it.productId && (it.variantId || it.variants.length > 0));

      if (items.length === 0) {
        console.warn('[ShoppableSlider] No items to review');
        return;
      }
      this.renderDrawer(items);
    }

    renderDrawer(items) {
      // Remove any existing drawer
      document.querySelectorAll('.rauve-edit-drawer-overlay').forEach(el => el.remove());

      const overlay = document.createElement('div');
      overlay.className = 'rauve-edit-drawer-overlay';
      overlay.innerHTML = `
        <div class="rauve-edit-drawer" role="dialog" aria-label="Review Edit Set">
          <div class="rauve-edit-drawer__header">
            <div class="rauve-edit-drawer__title">${this.editName ? this.editName.toUpperCase() : 'YOUR EDIT'} — FULL SET</div>
            <button class="rauve-edit-drawer__close" aria-label="Close">&times;</button>
          </div>
          <div class="rauve-edit-drawer__items"></div>
          <div class="rauve-edit-drawer__totals">
            <div class="rauve-edit-drawer__line"><span>Subtotal</span><span data-subtotal>$0.00</span></div>
            <div class="rauve-edit-drawer__line rauve-edit-drawer__line--discount"><span data-discount-label>Bundle discount (${this.bundleDiscountPercent}% off, applied at checkout)</span><span data-discount>-$0.00</span></div>
            <div class="rauve-edit-drawer__line rauve-edit-drawer__line--total"><span>Total</span><span data-total>$0.00</span></div>
          </div>
          <div class="rauve-edit-drawer__actions">
            <button class="rauve-edit-drawer__cta rauve-edit-drawer__cta--primary" data-action="add-bundle">ADD BUNDLE TO CART</button>
            <button class="rauve-edit-drawer__cta rauve-edit-drawer__cta--secondary" data-action="add-selected">Add Selected Only</button>
            <button class="rauve-edit-drawer__cta rauve-edit-drawer__cta--tertiary" data-action="cancel">Cancel</button>
          </div>
        </div>
      `;

      const itemsContainer = overlay.querySelector('.rauve-edit-drawer__items');
      items.forEach((item, idx) => {
        const el = document.createElement('div');
        el.className = 'rauve-edit-drawer__item';
        el.dataset.idx = idx;
        const variantPicker = item.requiresVariantChoice && item.variants.length > 0
          ? `<select class="rauve-edit-drawer__variant-picker" data-variant-picker>
              <option value="">Select option…</option>
              ${item.variants.map(v => `<option value="${v.id}" data-price="${v.price_cents || item.priceCents}" ${v.available === false ? 'disabled' : ''}>${v.title}${v.available === false ? ' (sold out)' : ''}</option>`).join('')}
            </select>`
          : '';
        el.innerHTML = `
          <label class="rauve-edit-drawer__item-row">
            <input type="checkbox" class="rauve-edit-drawer__checkbox" ${item.checked ? 'checked' : ''} data-checkbox>
            <img class="rauve-edit-drawer__item-image" src="${item.image}" alt="" loading="lazy">
            <div class="rauve-edit-drawer__item-body">
              <div class="rauve-edit-drawer__item-title">${item.productTitle}</div>
              ${variantPicker}
              <div class="rauve-edit-drawer__item-price">$${(item.priceCents / 100).toFixed(2)}</div>
            </div>
          </label>
        `;
        itemsContainer.appendChild(el);

        const checkbox = el.querySelector('[data-checkbox]');
        checkbox.addEventListener('change', () => {
          items[idx].checked = checkbox.checked;
          this.updateTotals(overlay, items);
        });
        const picker = el.querySelector('[data-variant-picker]');
        if (picker) {
          picker.addEventListener('change', () => {
            items[idx].selectedVariantId = picker.value || null;
            const priceCents = parseInt(picker.selectedOptions[0]?.dataset.price || item.priceCents, 10);
            items[idx].priceCents = priceCents;
            el.querySelector('.rauve-edit-drawer__item-price').textContent = `$${(priceCents / 100).toFixed(2)}`;
            this.updateTotals(overlay, items);
          });
        }
      });

      overlay.querySelector('[data-action="cancel"]').addEventListener('click', () => overlay.remove());
      overlay.querySelector('.rauve-edit-drawer__close').addEventListener('click', () => overlay.remove());
      overlay.addEventListener('click', (e) => { if (e.target === overlay) overlay.remove(); });
      overlay.querySelector('[data-action="add-bundle"]').addEventListener('click', () => this.submitDrawer(items, overlay, true));
      overlay.querySelector('[data-action="add-selected"]').addEventListener('click', () => this.submitDrawer(items, overlay, false));

      document.body.appendChild(overlay);
      requestAnimationFrame(() => overlay.classList.add('rauve-edit-drawer-overlay--open'));
      this.updateTotals(overlay, items);
    }

    updateTotals(overlay, items) {
      const checkedItems = items.filter(it => it.checked);
      const subtotalCents = checkedItems.reduce((s, it) => s + (it.priceCents || 0), 0);
      const deal = this.activeFullSetDeal(items);
      const discountCents = deal ? (deal.sumCents - deal.priceCents) : Math.round(subtotalCents * (this.bundleDiscountPercent / 100));
      const totalCents = subtotalCents - discountCents;
      const labelEl = overlay.querySelector('[data-discount-label]');
      if (labelEl) labelEl.textContent = deal ? 'Full set price (applied at checkout)' : `Bundle discount (${this.bundleDiscountPercent}% off, applied at checkout)`;
      overlay.querySelector('[data-subtotal]').textContent = `$${(subtotalCents / 100).toFixed(2)}`;
      overlay.querySelector('[data-discount]').textContent = `-$${(discountCents / 100).toFixed(2)}`;
      overlay.querySelector('[data-total]').textContent = `$${(totalCents / 100).toFixed(2)}`;
      overlay.querySelector('[data-action="add-bundle"]').textContent = `ADD BUNDLE TO CART ($${(totalCents / 100).toFixed(2)})`;
      overlay.querySelector('[data-action="add-selected"]').textContent = `Add Selected Only (${checkedItems.length} ${checkedItems.length === 1 ? 'item' : 'items'})`;
    }

    activeFullSetDeal(items) {
      const deal = this.fullSetDeals[this.editName];
      if (!deal || !items.length || !items.every(it => it.checked)) return null;
      const subtotalCents = items.reduce((s, it) => s + (it.priceCents || 0), 0);
      return subtotalCents === deal.sumCents ? deal : null;
    }

    submitDrawer(items, overlay, isBundle) {
      const checked = items.filter(it => it.checked);
      const needingVariant = checked.filter(it => it.requiresVariantChoice && !it.selectedVariantId);
      if (needingVariant.length > 0) {
        alert('Please choose an option for every selected item before adding to cart.');
        return;
      }
      const deal = isBundle ? this.activeFullSetDeal(items) : null;
      const bundleCode = deal ? deal.code : 'EDITSET20';
      const addItems = checked.map(it => ({
        id: it.selectedVariantId || it.variantId,
        quantity: 1,
        properties: isBundle ? { '_edit_bundle': this.editName || 'Edit', '_bundle_discount_percent': String(this.bundleDiscountPercent) } : {},
      }));
      const primaryBtn = overlay.querySelector('[data-action="add-bundle"]');
      primaryBtn.disabled = true;
      primaryBtn.textContent = 'Adding to cart…';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: addItems }),
      })
        .then(r => r.ok ? r.json() : Promise.reject(r))
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'edit-drawer', bundle: isBundle } }));
          // B2 fix: bundle adds auto-apply EDITSET20 (20% off order, min 2 items) so the drawer's promise is honoured (2026-10-14: was EDITSET10/10%)
          const root = window.Shopify.routes.root;
          if (!isBundle) { window.location.href = root + 'cart'; return; }
          // 2026-10-15: set code via cart API so stale codes from another Edit are replaced; fallback = /discount redirect
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: bundleCode }),
          })
            .then(r => { if (!r.ok) throw r; window.location.href = root + 'cart'; })
            .catch(() => { window.location.href = root + 'discount/' + bundleCode + '?redirect=' + encodeURIComponent(root + 'cart'); });
        })
        .catch(err => {
          console.error('[EditDrawer] cart/add failed', err);
          primaryBtn.disabled = false;
          primaryBtn.textContent = 'Try again';
          alert('There was an error adding your Edit to the cart. Please try again.');
        });
    }
  }
  customElements.define('shoppable-slider', ShoppableSlider);
}
